<!-- 采购单 -->
<template>
  <cc-container>
    <cc-header-nav title="采购单"/>
    <cc-main>
      <div class="list">
        <div class="leave-word" v-if="productList.length !== 0">
            <!-- <div class="leave-word-left">留言：{{leave.leaveContent}}</div>
            <div class="leave-word-right">
              <cc-svg-icon icon-class="leave" @click="isShowLeave = true"/>
            </div> -->
            <label for="">留言</label>
            <div ref="textarea" @input="leaveHandler" placeholder="点击输入！" class="textarea" contenteditable="true"></div>
        </div>
          <!-- 商品列表 -->
          <van-list
            v-model="m_loading"
            :finished="m_finished"
            :finished-text="m_finishedText"
            @load="mHandlePullUpLoadMore"
            :immediate-check="m_immediateCheck"
          >
            <cc-not-order
            :isRouter="true"
            url="/purchase/product-stocks"
            v-if="productList.length === 0 && m_loading === false"
            btnWord="去采购"
            tip="采购单暂无商品">
            </cc-not-order>
            <cc-animation-list>
              <div class="goods" v-for="(product,index) in productList" :key="index">
                <div class="goods-select">
                  <van-checkbox @change="selectProduct()" v-model="product.selected" checked-color="#07c160"></van-checkbox>
                </div>
                <div class="goods-img">
                  <img :src="product.img || noImg" alt="">
                </div>
                <ul class="goods-info">
                  <li class="f14 fw-bold">{{product.name}}</li>
                  <li>{{product.specif}}</li>
                  <li>{{product.company}}</li>
                  <li class="one-line"><van-tag type="danger" color="#F92D6C" style="margin-right:5px;padding:0 3px;">供</van-tag>{{product.supplier}}</li>
                  <li class="mb6">采购价：<span class="goods-price">￥{{product.price}}</span></li>
                  <li class="goods-num">
                    <cc-stepper
                      async-change
                      :min="1"
                      v-model="product.num"
                      v-on:plus="addGoods(product.ident,index)"
                      v-on:minus="reduceGoods(product.ident,index)"
                      />
                  </li>
                </ul>
              </div>
            </cc-animation-list>
          </van-list>
        </div>
        <van-submit-bar
         v-if="productList.length !== 0"
          :price="totalPrice"
          button-text="提交采购计划"
          @submit="submitPurchase"
          :class="isSubmit?'has-goods':'not-goods'"
        >
          <van-checkbox v-model="isSelectAll"  checked-color="#07c160">全选</van-checkbox>
          <span class="remove-goods" @click="delGoods">删除</span>
        </van-submit-bar>
    </cc-main>
    <cc-footer>
      <cc-nav></cc-nav>
    </cc-footer>
  </cc-container>
</template>

<script>
import Vue from 'vue'
import { List, Tag, SubmitBar, Checkbox, Dialog, Toast, Field } from 'vant'

import { ResultCode } from '~const/ResultCode'
import ListMixin from '@/mixins/list'
import { mapGetters, mapActions } from 'vuex'

Vue.use(List)
  .use(Tag)
  .use(SubmitBar)
  .use(Checkbox)
  .use(Dialog)
  .use(Toast)
  .use(Field)
export default {
  mixins: [ ListMixin ],
  components: {},

  data () {
    return {
      noImg: require('~assets/img/ungoodsphoto.png'),
      totalPrice: 0,
      isShowLeave: false, // 是否显示留言弹窗
      loading: false,
      finished: false,
      productList: [
      ],
      leaveContent: ''

    }
  },

  computed: {
    ...mapGetters(['getGoodsTotalNum', 'getDelGoodsStatus', 'getCartData', 'getSelectedGoods', 'getGoodsNumPrice', 'getGoodsCartStatus']),
    isSubmit () {
      return this.productList.filter(item => item.selected).length > 0
    },
    isSelectAll: {
      get: function () {
        return this.productList.every(item => {
          return item.selected
        })
      },
      set: function (newVal) {
        if (newVal) {
          this.productList.forEach(item => {
            item.selected = true
          })
        } else {
          this.productList.forEach(item => {
            item.selected = false
          })
        }
        this.updateSelectProduct()
      }
    }

  },
  // activated () {
  //   this.loadData()
  // },
  created () {
    this.loadData()
  },

  methods: {
    ...mapActions(['GOODS_NUM', 'DEL_GOODS', 'LOAD_CART_DATA', 'SELECT_CART', 'UPDATE_GOODS_NUM_PRICE', 'POST_GOODS_CART']),
    leaveHandler () {
      if (this.$refs.textarea.innerText.length > 200) {
        this.$refs.textarea.innerText = this.$refs.textarea.innerText.substring(0, 200)
      }
    },
    /**
     * @description 加载商品列表数据
     */
    async loadData () {
      this.GOODS_NUM()
      this.mRequest()
      await this.LOAD_CART_DATA()
      if (this.getCartData.status === ResultCode.SUCCESS) {
        this.mEnd()
        if (this.getCartData.data.list.length === 0) {
          this.m_finishedText = ''
          this.productList = []
        } else {
          this.productList = this.getCartData.data.list.map(item => {
            return {
              id: item.goods.id,
              ident: item.ident,
              name: item.goods.general_name,
              specif: item.goods.norms,
              company: item.goods.factory_name,
              supplier: item.goods.supplier_name,
              price: item.goods.price,
              num: parseInt(item.quantity),
              selected: true,
              img: item.goods.image_list
            }
          })
        }
        // 完善一开始加载页面合计不正确问题
        this.updateSelectProduct()
      }
      // 加载状态结束
      this.loading = false
    },
    /**
     * @description 提交采购
     */
    async submitPurchase () {
      let idents = []
      this.productList.forEach(item => {
        if (item.selected) {
          idents.push(item.ident)
        }
      })
      if (idents.length <= 0) {
        Toast('请选择需要提交的商品')
      } else {
        const params = {
          idents: idents.toString(),
          remark: this.$refs.textarea.innerText,
          total_price: this.totalPrice / 100
        }
        await this.POST_GOODS_CART(params)
        const { status, data } = this.getGoodsCartStatus
        if (status === ResultCode.SUCCESS) {
          this.GOODS_NUM()
          this.$router.push({
            name: 'shopping-cart-success',
            query: {
              id: data.plan_order_number
            }
          })
          Toast('提交采购计划成功')
        }
      }
    },
    async updateGoodsNumPrice (ident, index) {
      const data = {
        quantity: this.productList[index].num,
        ident
      }
      await this.UPDATE_GOODS_NUM_PRICE(data)
      if (this.getGoodsNumPrice.status === ResultCode.SUCCESS) {
        this.updateSelectProduct()
        this.GOODS_NUM()
      }
    },
    /**
     * @description 增加商品数量计算商品价格
     */
    addGoods (ident, index) {
      this.updateGoodsNumPrice(ident, index)
    },
    /**
     * @description 减少商品数量计算商品价格
     */
    reduceGoods (ident, index) {
      this.updateGoodsNumPrice(ident, index)
    },
    /**
     * @description 获取勾选商品的idents,并计算价格
     */
    async updateSelectProduct () {
      let idents = []
      await this.$nextTick()
      this.productList.map(item => {
        if (item.selected) {
          idents.push(item.ident)
        }
      })
      await this.SELECT_CART({ idents: idents.toString() })
      const { status, data } = this.getSelectedGoods
      if (status === ResultCode.SUCCESS) {
        this.totalPrice = data.sum_price * 100
      }
    },
    /**
     * @description 勾选商品
     */
    async selectProduct () {
      await this.$nextTick()
      this.updateSelectProduct()
    },
    /**
     * @description 全选
     */
    selectAll () {
      if (!this.isSelectAll) {
        this.productList.forEach(item => {
          item.selected = false
        })
      } else {
        this.productList.forEach(item => {
          item.selected = true
        })
      }
      this.updateSelectProduct()
    },
    /**
     * @description 删除商品
     */
    delGoods () {
      let idents = []
      this.productList.forEach(item => {
        if (item.selected) {
          idents.push(item.ident)
        }
      })
      if (idents.length > 0) {
        Dialog.confirm({
          message: '您确定要删除选中的商品吗？'
        }).then(async () => {
          await this.DEL_GOODS({
            idents_id: idents.toString()
          })
          let { msg, result } = this.getDelGoodsStatus
          if (result) {
            Toast(msg)
            this.loadData()
            this.GOODS_NUM()
          }
        }).catch(() => {
          // on cancel
        })
      } else {
        Toast('请选择您要删除的商品')
      }
    }
  }
}

</script>
<style lang='scss' scoped>
.list{
  height: calc(100% - 50px);
  overflow: scroll;
  padding-bottom: 50px;
}
.leave-word{
  min-height: 44px;
  width: 100%;
  background:rgba(255,255,255,1);
  box-sizing: border-box;
  padding: 0 10px;
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(229,229,229,1);
  z-index: 10;
  position: relative;
  label{
    width: 30px;
    display: inline-block;
    height: 44px;
    box-sizing: border-box;
    padding-top: 15px;
    position: absolute;
    top: 0;
  }
  .textarea{
    width: calc(100% - 30px);
    border: none;
    height: auto;
    margin: 10px 0;
    margin-left: 35px;
    &:empty:before{
        content: attr(placeholder);
        color:#F92D6C;
    }
    &:focus:before{
        content:none;
    }
  }
  input{
    width: calc(100% - 30px);
    border: none;
    height: 42px;
    outline: none;
  }
   input::-webkit-input-placeholder{
        color:#F92D6C;
    }
    input::-moz-placeholder{   /* Mozilla Firefox 19+ */
        color:#F92D6C;
    }
    input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
        color:#F92D6C;
    }
    input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
        color:#F92D6C;
    }
}
.goods{
  width: 100%;
  background: #ffffff;
  height: 140px;
  padding: 10px;
  display: flex;
  margin-bottom: 8px;
  background:rgba(255,255,255,1);
  box-sizing: border-box;
  box-shadow:$box-shadow-base;;
  &-select{
    width: 40px;
    height: 100%;
    display: flex;
    align-items: center;
  }
  &-img{
    width: 120px;
    height: 120px;
    background: #cccccc;
    img{
      width: 100%;
      height: 100%;
    }

  }
  &-info{
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 185px;
    li{
      overflow: hidden;/*超出部分隐藏*/
      white-space: nowrap;/*不换行*/
      text-overflow:ellipsis;/*超出部分文字以...显示*/
    }
    .shopping-cart{
       margin-left: 10px;
       color: var(--APP_theme_color);

    }
  }
  &-price{
    color: #F92D6C;
    font-weight: bolder;
  }
}
.line{
  height:88px;
}
.one-line{
  @include ell();
}
.van-submit-bar{
  position: fixed;
  bottom:  50px;
  /deep/{
    .van-checkbox{
      margin-left: 10px;
    }
    .van-checkbox__icon--checked{
      i{
        background:var(--APP_theme_color)!important;
        border-color: var(--APP_theme_color)!important;
      }
    }
    .van-button--danger{
      background:#cccccc;
      border:1px solid #cccccc;
    }
    .van-submit-bar__price{
      color: #F92D6C;
    }
  }
}
.has-goods{
  .van-button--danger{
      background:var(--APP_theme_color);
      border-color:1px solid  var(--APP_theme_color);
    }
}
.goods-select{
  /deep/{
    .van-checkbox__icon--checked{
      i{
        background:var(--APP_theme_color)!important;
        border-color: var(--APP_theme_color)!important;
      }
    }
  }
}
.leave-content{
  margin: 0 auto 19px;
  display: block;
  width: 229px;
  height: 66px;
  resize:none;
  border:1px solid rgba(229,229,229,1);
}
.cc-container{
  /deep/{
    .van-dialog__header{
      width: 230px;
      margin: auto;
      text-align: left;
      padding-bottom: 3px;
    }
    .van-dialog__confirm, .van-dialog__confirm:active{
      color: var(--APP_theme_color);
    }
  }

}
.remove-goods{
  display: inline-block;
  vertical-align: middle;
  line-height: 0.2rem;
  margin-left: 10px;
}
.fw-bold{
  font-weight: bold;
}
</style>
